<template>
<div  class="container-fluid">


    <!-- Modal CONFIRM -->
    <modalConfirm ref="confirmModal" />

     <!-- Modal MESSAGE -->  
    <modalMessage ref="msgModal"/>


<!-- PRODUCT MASTER  -->
<div v-if="type=='A'">
<div class="row">
<div class="col">
 
  <check-product ref="checkModal" @createProduct="createProduct()" @update="setProduct"  v-bind:items="items"  ></check-product>
  
  <div v-if="product.productId==0">
    <!-- <h4 style="color:navy" class="text-center"><strong>PRODOTTO NUOVO</strong></h4>-->
  </div>  
  <div v-else>
    <h4 style="color:red" class="text-center"><strong>PRODOTTO ESISTENTE ID [{{product.productId}}] </strong> </h4>
  </div>

  
   <div class="btn-toolbar " role="toolbar" aria-label="Toolbar with button groups"> 
    <div class="btn-group btn-group-lg ml-2 mb-1">    

    
  <div class="btn-group" role="group">
    

    <button @click="type='B'" type="button"  data-toggle="tooltip" title="Ricerca prodotto del fornitore." class="btn btn-outline-primary mr-2">
      <i class="fas fa-binoculars mr-2" aria-hidden="true"></i>    
      RICERCA PRODOTTI
    </button> 

    <button id="btnGroupDrop1" type="button" class="btn btn-outline-primary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
      <i class="fas fa-edit " aria-hidden="true"></i>
      CLASSIFICAZIONE
    </button>

    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
      <a @click="lineModal()" class="dropdown-item" href="#">LINEA</a>
      <a @click="type='C'" class="dropdown-item" href="#">CATEGORIA</a>
      <a v-if="false" @click="type='D'" class="dropdown-item" href="#">ATTRIBUTI</a>
    </div>
  </div>


  
  <button @click="setNewProduct()" type="button" data-toggle="tooltip" title="Reset anagrafica prodotto." class="btn btn-outline-primary rounded-sm ml-3">
    <i class="fas fa-trash" aria-hidden="true"></i>
   
  </button> 

</div>

 </div>
 

 
    <form name="productMaster" v-on:submit.prevent="submit()">
      <fieldset :disabled="product.productId > 0">

      
      <div  class="card bg-light text-dark">
      <div class="card-body">
      <div class="row">

        <!-- SUPPLIER -->
        <div class="col">
          <div class="form-group">
            <supplier-select v-bind:Id="supplierId" v-bind:isActive="false"></supplier-select>
          </div>
        </div>

        <!-- BRAND -->
        <div class="col">          
          <div class="form-group">
            <supplier-brand-select  @update="setBrand" v-bind:_brand="product.brand" v-bind:required="true" v-bind:supplierId="supplierId"></supplier-brand-select>
          </div>
        </div>

        <!-- SKU -->
        <div class="col">
          <div class="form-group">
            <label for="codice"><strong>Codice prodotto del Fornitore</strong></label>
            <input autocomplete="off" required v-model = "product.sku" type="text" class="form-control bold" placeholder="" id ="sku" name="sku">            
          </div>
        </div>
        <!-- ROW -->
      </div>
      <!-- CARD BODY -->
      </div>
      <!-- CARD -->
      </div>
      
      <div  class="card bg-light text-dark">
      <div class="card-body">
        <div class="row">
        <div class="col">    

          <!-- LINE MODAL -->
          <div class="col-md-4_">
            <line-modal @update="refreshLine" v-bind:supplierId="supplierId"></line-modal>  
          </div>

          <div class="form-group">            
            <!-- LINE -->
            <line-select :key="lineKey"  @update="setLine" v-bind:Id="product.lineId" v-bind:supplierId="supplierId"></line-select>                                              
          </div>

        </div>

        <!-- CATEGORY -->
        <div class="col">    
          <div class="form-group">       
            <category-vue-select :key="categoryKey" @input="setCategoryId" v-bind:props="category" v-bind:disabled="isCategoryDisabled"></category-vue-select>
          </div>
        </div>

        <!-- DESCRIPTION -->
        <div class="col">    
        <div class="form-group">
          <label for="descrizione">Descrizione</label>
          <input  v-model="product.description" type="text" class="form-control bold" placeholder="" id ="descrizione">
        </div>
        </div>
        <!-- ROW -->
        </div>
        <div class="row">
        <div class ="col-sm">  
        <div class="form-group">
        <!-- DEPARTMENT -->
        <department-select :key="departmentKey" v-bind:Id="product.departmentId" @update="setDepartment" v-bind:required="true" v-bind:isActive="true" v-bind:type="true"></department-select>
        </div>
            </div>
            <div class ="col-sm">  
              <div class="form-group">
              <!-- SEASON -->
              <season-select :key="seasonKey" @update="setSeason" v-bind:Id="product.seasonId" v-bind:required="true" v-bind:isActive="true" v-bind:type="true"></season-select>
                
              </div>

            </div>
            <div class ="col-sm"> 
            <div class="form-group">
              <!-- YEAR -->
              <year-select :key="yearKey" @update="setYear" v-bind:required="true" v-bind:_year="product.season_year" v-bind:isActive="true"></year-select>   
              </div>      


            </div>
          </div>
          
          <div class="row">

          <div class="col-sm">    
          <div class="form-group">
            <label for="composizione">Composizione</label>
            <input  v-model="product.material" type="text" class="form-control bold" placeholder="" id ="material">
          </div>
          </div>

          <div class="col-sm">    
          <div class="form-group">
            <label for="dimension">Dimensione</label>
            <input  v-model="product.dimension" type="text" class="form-control bold" placeholder="" id ="dimension">
          </div>
          </div>

          <div class="col-sm">    
          <div class="form-group">
            <label for="dimension">Made In</label>
            <input  v-model="product.madeIn" type="text" class="form-control bold" placeholder="" id ="madeIn">
          </div>
          </div>
          

          

          </div>
          <div class="form-group">
            <productAttributes v-if="false" v-bind:productId="product.productId"></productAttributes>  
          </div>
          
      </div>
      </div>

      </fieldset>

    <button type="submit"  class="btn btn-primary float-right mt-2">
      
      <i v-if="product.productId" class="far fa-arrow-alt-circle-right mr-2" aria-hidden="true"></i>
      <i v-else class="far fa-save mr-2" aria-hidden="true"></i>            
      {{product.productId == 0 ? 'SALVA I DATI E PROCEDI':'PROCEDI'}}
       
    </button> 
           
    </form>
   

  <!-- COL -->
  </div>

  <!-- ROW -->
  </div>
</div>
<div v-else-if="type=='C'">
    <div class="ml-3 mr-3">
    <button @click="type='A'" class="btn btn-secondary  mb-2">      
                <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
                    RITORNA AL PRODOTTO
  </button>
  </div>    
  <category></category> 

</div>  
<div v-else-if="type=='D'">
  <div class="ml-3 mr-3">
    <button @click="type='A'" class="btn btn-secondary  mb-2">      
                <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
                    RITORNA AL PRODOTTO
  </button>
  </div>  

  <!--<gestione-attributi v-bind:productId="product.productId"></gestione-attributi>-->

</div>  

<div v-else>
  <find-product v-bind:supplierId="supplierId" @update="setProduct"></find-product>
</div>  
  





 <div v-if="false">
      <h5 class="mb-4">Dati JSON:</h5>
      <pre> {{ order }} </pre> 
      
    </div>



  <!-- MAIN DIV -->
  </div>    

</template>
<script>



import api                   from '@/api'
import supplierSelect        from '@/components/common/SupplierSelect.vue' 
import supplierBrandSelect   from '@/components/common/SupplierBrandSelect.vue'

import lineSelect            from '@/components/common/LineSelect.vue'
import seasonSelect          from '@/components/common/SeasonSelect.vue'
import departmentSelect      from '@/components/common/DepartmentSelect.vue'
import yearSelect            from '@/components/common/YearSelect.vue'
import lineModal             from '@/components/common/LineModal.vue'
import findProduct           from '@/components/product/FindProduct.vue'


import category              from '@/components/category/Category.vue'

import checkProduct          from '@/components/product/ModalCheckMatchingProducts.vue'
import categoryVueSelect     from '@/components/common/CategoryVueSelect.vue'


import modalMessage                from '@/components/modalDialog/ModalMessage.vue'         
import modalConfirm                from '@/components/modalDialog/ModalConfirm.vue'

//import productAttributes     from '@/components/product/AttributiProdotto.vue'
//import gestioneAttributi     from '@/components/product/GestioneAttributi.vue'

import { mapGetters }        from 'vuex';

// import GestioneAttributi from '../product/GestioneAttributi.vue'

import { v4 as uuidv4 }      from 'uuid'
export default { 
  props : ['supplierId','_product','order'] , 
  components: {supplierSelect,supplierBrandSelect,lineSelect,seasonSelect,departmentSelect,yearSelect,lineModal,findProduct,category,checkProduct,categoryVueSelect,modalConfirm,modalMessage
        

  },
  
  data () {
      return {

        orderId         : this.order.orderId,
        type            : 'A',  
        product         : this._product,
        category        : {'Id': this._product.categoryId,
         
        },
        

      
      
        lineKey          : 0,
        
        categoryKey      : 100,
        brandKey         : 200,
        departmentKey    : 300,
        seasonKey        : 400,
        yearKey          : 500,
        refresh          : 0,
        items            : [],
        // btn              : false,
        uuid             : ''
        
       
        }
    },
    computed: 
    {     
     ...mapGetters(['company']) ,

     isCategoryDisabled() {
       return this.product.productId > 0
      }
      
    },
          
    directives: 
    {
      focus: {
      // directive definition
        inserted: function (el) {
          el.focus()}
       
      }
    },
    mounted()
    {
    },
    created () 
    {
      //console.log('_Product',this._product)
      this.uuid = uuidv4()


    },
  

  methods: 
  {

    setCategoryId(categoryId)
    {
      this.product.categoryId = categoryId
    },

    setNewProduct()
    {

      // FAKE DIV
      this.type = 'C'
    
      this.product            = {}
      this.product.productId  = 0
      this.product.supplierId = this.supplierId
      this.product.barcodes   = []
      this.product.counter    = 0 
      this.category.Id        = ''
     
      this.$nextTick(function () {
        this.type = 'A'
      })
      
      
    },
    setProduct(product)
    { 
      product.supplierId = this.supplierId
      // $('#checkProduct-modal-lg').modal('hide');
      if(product.productId == 0)
      {
        this.setNewProduct()
        this.type = 'A'
      }
      else
      {
        
        if(this.orderId)
        {
          // ORDER 
          this.checkInOrder(this.orderId,product)
        }
       
      }

      

    },
    refreshLine()
    {
      $('#lineModal').modal('hide');
      this.lineKey++
    },
    setBrand(brand)
    {
      this.product.brand = brand
    },
    setLine(lineId)
    {      
      this.product.lineId = lineId
    },

    
    setDepartment(departmentId)
    {
      this.product.departmentId = departmentId
    },
    setSeason(seasonId)
    {
      this.product.seasonId = seasonId
    },
    setYear(year)
    {
      this.product.season_year = year
    },
    lineModal()
    {
      $('#lineModal').on('shown.bs.modal', function (e) {
        $('#inputLine').val('');
        $('#inputLine').trigger('focus');
      })
      $('#lineModal').modal({keyboard: false,backdrop:'static'});
    },

    async submit() 
      {
        
        

        // CONTROLLO ANNO E STAGIONE 
        if(this.product.seasonId != this.order.collection_seasonId || this.product.season_year != this.order.collection_year)
        {
            let msg = 'L\'ANNO E/O LA STAGIONE ANAGRAFICA DEL PRODOTTO NON COINCIDONO CON QUELLI DELLA COLLEZIONE.'
            msg += '\n\nPROCEDO COMUNQUE   ?'
            const confirmed=  await this.$refs.confirmModal.show(msg
            ,
            { title: '' },1)

            if (!confirmed) return  
            this.$refs.confirmModal.close()
        }

        if(this.product.productId==0)
        {
          
          try{
              
              this.items = await this.isProductCreated(this.product)  
              if(this.items[0].length == 0)
              {
                // NON ESISTE 
                this.createProduct()      
                return
              }

              // ESISTONO OMONIMIE

              // this.btn   = this.items[1].length > 0             
              // this.refresh++
              
              this.$nextTick(() => {
                this.$refs.checkModal.show()
                                
                })
                
              
                
          }
          catch(err)                    
          {
              this.$refs.msgModal.show(err)
              return
          }
                    
          

        }
        else
        {
          this.$emit('update',this.product)   
        }
        
        
        
      },  
      
      async isProductCreated(product)
      {
                
        const sp         = 'spCheckIfProductIsCreatedNew'          
        const payload    = {...product,
                            'supplierId' : this.supplierId,
                            'companyId'  :  this.company.Id,sp
                          }
      
      
        this.$refs.msgModal.show('',{'spinner' : true,'title':'ELABORAZIONE IN CORSO ...'},5)      
        try{

            const res = await api.post(payload)
        
            if (res.status !== 200) 
            {
                throw new Error(res.data ||  res)
            }
            
            this.$refs.msgModal.close()
            return res.data.recordsets
            

        }
        catch(err){

            
            const msg = err.message
            this.$refs.msgModal.show(msg)
            throw err
            

        }
      },
    async checkInOrder(orderId,product)
    {
              
        const sp        = 'spOrderProduct_CheckIn'
        const payload   = {'orderId':orderId, 'productId' : product.productId,sp}
        this.$refs.msgModal.show('',{'spinner' : true,'title':'ELABORAZIONE IN CORSO ...'},5)        

         try{

          const res = await api.post(payload)

          if (res.status !== 200) 
          {
            throw new Error(res.data ||  res)
          }

          this.$refs.msgModal.close()  
          
          if(res.data.recordsets[0].length > 0)
              {                
                this.$refs.msgModal.show("PRODOTTO CODICE ARTICOLO  [ " + product.sku + " ] GIA\' PRESENTE NELL\'ORDINE.",{},1)                  
              }
              else
              {
                this.product = product
                this.category.Id = product.categoryId            
              }


              this.type = 'A'         
                      
        }catch(err)
        {
          this.$refs.msgModal.show(err)
        }
           
    },

    async createProduct()
    {
       
        const uuid       = this.uuid
        const supplierId = this.supplierId        
        const companyId  = this.company.Id
        const sp         = 'spCreateProductNewRequestLog'
        const payload    = {...this.product,sp,companyId,supplierId,uuid

        }
                 
         this.$refs.msgModal.show('',{'spinner' : true,'title':'ELABORAZIONE IN CORSO ...'})        
         try{

          const res = await api.post(payload)
          if (res.status !== 200) 
          {
            throw new Error(res.data ||  res)
          }
          
          this.$refs.msgModal.close()  
          this.product.productId  = res.data.recordsets[0][0].id
          this.product.counter    = 1
          this.product.supplierId = this.supplierId
          this.$emit('update',this.product)              
                
        }catch(err)
        {
          this.$refs.msgModal.show(err)
        }
        
    },  



    
    }
  
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.btn_1
{
  font-family      : 'Roboto Condensed';
  background-color : khaki;
  color            : black
}
.btn_2
{
  font-family      : 'Roboto Condensed';
  background-color :  khaki;
  color            : black
}

.btn-sm:hover {

    background-color : navy !important;
    color            : white
}
label,i,span:hover {
   
   cursor    : pointer 
   
}
span{
  font-family: 'Roboto Condensed';
}

label{
  color:black
  
}
.bold {
font-weight: bolder;
}

h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}

</style>
